// extracted by mini-css-extract-plugin
export default {"container":"Reactor_container__GSJRS","grid":"Reactor_grid__AOZQk"};